export default __webpack_public_path__ + "static/media/ad.bf24bba3.svg";